<template>
    <div>
        <div class="ticket-search-filter">
            <div class="container p-0">
                <form class="form-inline">
                    <div class="col-md-6 col-lg-5 date-start">
                        <div class="ftSWJG njlolp">
                            <span class="dFcWyt ant-input-affix-wrapper ant-input-affix-wrapper-lg lolpplp">
                                <span class="ant-input-prefix">
                                    <img src="../../../assets/images/datepicker.svg" alt="">
                                </span>
                                <custom-datepicker v-model="queryParams.from"
                                                   :isDisabledDates="false"
                                                   :clear-button="true"
                                                   :placeholder="'Lọc từ ngày'">

                                </custom-datepicker>
                            </span>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 date-start">
                        <div class="ftSWJG njlolp">
                            <span class="dFcWyt ant-input-affix-wrapper ant-input-affix-wrapper-lg lolpplp">
                                <span class="ant-input-prefix">
                                    <img src="../../../assets/images/datepicker.svg" alt="">
                                </span>
                                <custom-datepicker v-model="queryParams.to"
                                                   :isDisabledDates="false"
                                                   :clear-button="true"
                                                   :is-filter-to="true"
                                                   :placeholder="'Lọc đến ngày'">

                                </custom-datepicker>
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-2 btn-find text-right">
                        <button id="searchSubmit" name="searchSubmit" type="button" class="btn"
                                @click.stop="findOrders">
                            Tìm kiếm
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <section class="searchResults">
            <div id="main">
                <div class="replaceDiv">
                    <div id="searchResults">
                        <ul class="result-list" v-if="orders && orders.length > 0">
                            <template v-for="(item) in orders">
                                <li v-bind:key="item.id" v-bind:id="item.id"
                                    class="result-item col-12 col-sm-12 col-md-12">
                                    <div class="container">
                                        <div class="display-desktop">
                                            <div class="row mr-0 ml-0">
                                                <div class="col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <h6 class="mt-0 mb-3">
                                                                Tuyến đường
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <h6 class="mt-0 mb-3">
                                                                Thời gian khởi hành
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <h6 class="mt-0 mb-3">
                                                                Khách hàng
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <h6 class="mt-0 mb-3">
                                                                Giá vé
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <h6 class="mt-0 mb-3">
                                                                Trạng thái chuyến đi
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mr-0 ml-0">
                                                <div class="col-2 col-md-3 col-sm-3 col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <p class="mt-0 mb-3" title="Luxury Transport">
                                                                {{getProp(item, 'schedule.voyage.from', '')}} -
                                                                {{getProp(item, 'schedule.voyage.to', '')}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 col-md-5 col-sm-3 col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <p class="mt0 mb-1">
                                                                {{format(new Date(getProp(item,
                                                                'schedule.start_time', 0)), 'HH:mm')}}
                                                                - {{format(new Date(getProp(item,
                                                                'schedule.end_time', 0)), 'HH:mm dd/MM/yyyy')}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 col-md-5 col-sm-3 col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <p class="mt0 mb-1">
                                                                {{getProp(item, 'customer.name', '')}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-4 col-md-5 col-sm-3 col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <p class="mt0 mb-1">
                                                                {{getProp(item, 'total_price_pretty', '')}}
                                                                <small style="vertical-align: top;"
                                                                       class="unit-price-small">đ
                                                                </small>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-4 col-md-5 col-sm-3 col-lg-2">
                                                    <div class="row">
                                                        <div class="pull-left">
                                                            <p class="mt0 mb-1" :class="{
                                                            'color-danger': status.reject === getProp(item, 'status'),
                                                            'color-success': status.success === getProp(item, 'status'),
                                                            'color-warning': status.processing === getProp(item, 'status'),
                                                            }">
                                                                {{getProp(item, 'status_title', '')}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-4 col-md-2 col-sm-3 col-lg-2 pr-0 text-right"
                                                     style="margin-top: -30px">
                                                    <p class="m-0">
                                                        <a v-if="!item.displayDetail"
                                                           class="btn btn-detail pull-right w100"
                                                           href="javascript:void(0)"
                                                           title="Nhấp để xem chi tiết"
                                                           @click="openDetail(item)">Chi tiết
                                                        </a>
                                                        <a v-if="item.displayDetail"
                                                           title="Nhấp để đóng lại"
                                                           href="javascript:void(0)"
                                                           class="btn btn-lg btn-detail-close pull-right w100"
                                                           @click="closeDetail(item)">Đóng lại
                                                        </a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="display-mobile">
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-5">
                                                        <div>
                                                            <h6>Tuyến</h6>
                                                        </div>
                                                    </div>
                                                    <div class="col-7 text-right">
                                                        <p class="mt-0">
                                                            {{getProp(item, 'schedule.voyage.from', '')}} -
                                                            {{getProp(item, 'schedule.voyage.to', '')}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <div>
                                                            <h6>Thời gian</h6>
                                                        </div>
                                                    </div>
                                                    <div class="col-7 text-right">
                                                        <p class="mt-0">
                                                            {{format(new Date(getProp(item,
                                                            'schedule.start_time', 0)), 'HH:mm')}}
                                                            - {{format(new Date(getProp(item,
                                                            'schedule.end_time', 0)), 'HH:mm dd/MM/yyyy')}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <div>
                                                            <h6>Khách hàng</h6>
                                                        </div>
                                                    </div>
                                                    <div class="col-7 text-right">
                                                        <p class="mt-0">
                                                            {{getProp(item, 'customer.name', '')}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <div>
                                                            <h6>Giá vé</h6>
                                                        </div>
                                                    </div>
                                                    <div class="col-7 text-right">
                                                        <p class="mt-0">
                                                            {{getProp(item, 'total_price_pretty', '')}}
                                                            <small style="vertical-align: top;"
                                                                   class="unit-price-small">đ
                                                            </small>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-5">
                                                        <div>
                                                            <h6>Trạng thái chuyến đi</h6>
                                                        </div>
                                                    </div>
                                                    <div class="col-7 text-right">
                                                        <p class="mt-0 mb-1" :class="{
                                                            'color-danger': status.reject === getProp(item, 'status'),
                                                            'color-success': status.success === getProp(item, 'status'),
                                                            'color-warning': status.processing === getProp(item, 'status'),
                                                            }">
                                                            {{getProp(item, 'status_title', '')}}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12 text-right">
                                                        <p style="margin:0;">
                                                            <a v-if="!item.displayDetail"
                                                               class="btn btn-detail pull-right w100"
                                                               href="javascript:void(0)"
                                                               title="Nhấp để xem chi tiết"
                                                               @click="openDetail(item)">Chi tiết
                                                            </a>
                                                            <a v-if="item.displayDetail"
                                                               title="Nhấp để đóng lại"
                                                               href="javascript:void(0)"
                                                               class="btn btn-lg btn-detail-close pull-right w100"
                                                               @click="closeDetail(item)">Đóng lại
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li v-bind:key="item.id + '-detail'" v-if="item.displayDetail"
                                    class="ticket-booking-details col-12 col-md-12 col-xs-12 pb-3 pt-2 m-0">
                                    <order-detail :order_id="item.id"></order-detail>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="spin" ref="loadContainer">
        </section>
    </div>
</template>

<script>
    import { CustomDatepicker } from "../../shared/components";
    import {RepositoryFactory, MixinHelper, eventBus, EVENTS} from "../../shared/services";
    import format from 'date-fns/format';
    import OrderDetail from "../order-detail/OrderDetail";

    const repo = RepositoryFactory.get('orders');
    export default {
        name: "Orders",
        mixins: [MixinHelper],
        components: {OrderDetail, CustomDatepicker},
        created() {
            this.listOrders(this.queryParams);
            eventBus.$on(EVENTS.reject_order, this.handleRejectOrder);
        },
        mounted() {
            this.scroll();
        },
        data() {
            return {
                orders: [],
                meta: null,
                queryParams: {
                    from: null,
                    to: null,
                    page: 1,
                    limit: 15
                },
                format,
                status: {
                    processing: 1,
                    success: 2,
                    reject: -1
                }
            }
        },
        methods: {
            findOrders() {
                this.orders = [];
                this.queryParams.page = 1;
                eventBus.$emit(EVENTS.off_not_found_page);
                this.listOrders(this.queryParams);
            },
            listOrders(params) {
                repo.list(params)
                    .then(resp => {
                        this.orders = this.getProp(resp, 'data.datas', []).map(function (order) {
                            return {...order, displayDetail: false};
                        });
                        this.meta = this.getProp(resp, 'data.meta', null);
                        if (!this.orders || this.orders.length === 0) {
                            eventBus.$emit(EVENTS.not_found);
                        }
                    })
                    .catch(err => {
                        eventBus.$emit(EVENTS.not_found);
                    })
            },
            loadMoreOrders(params) {
                const loader = this.$loading.show({
                    container: this.$refs.loadContainer,
                    color: '#f9af00',
                });
                repo.loadMore(params)
                    .then(resp => {
                        this.orders = [...this.orders, ...this.getProp(resp, 'data.datas', []).map(function (order) {
                            return {...order, displayDetail: false};
                        })];
                        this.meta = this.getProp(resp, 'data.meta', null);
                    })
                    .catch(err => {
                    })
                    .finally(() => loader.hide())
            },
            openDetail(item) {
                this.orders.map(function (order) {
                    order.displayDetail = false;
                });
                item.displayDetail = true;
            },
            closeDetail(item) {
                item.displayDetail = false;
            },
            scroll() {
                window.onscroll = () => {
                    let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.scrollHeight - 1;
                    if (bottomOfWindow) {
                        if (this.queryParams.page < this.getProp(this.meta, 'last_page', 0)) {
                            this.queryParams.page++;
                            this.loadMoreOrders(this.queryParams);
                        }
                    }
                }
            },
            handleRejectOrder(orderReject) {
                const order = this.orders[this.orders.findIndex(order => order.id === orderReject.id)];
                order.status = orderReject.status;
                order.status_title = orderReject.status_title;
                order.displayDetail = false;
            }
        },
        beforeDestroy() {
            eventBus.$emit(EVENTS.off_not_found_page);
            eventBus.$off(EVENTS.reject_order);
        }
    }
</script>

<style>
    .btn-detail {
        box-sizing: content-box;
        display: inline-block;
        padding: 10px 10px 10px 10px;
        color: #684d18;
        font-weight: 700;
        font-size: 14px;
        background-position: top left, top right;
        background-color: transparent !important;
        border: none;
        box-shadow: none;
        border-radius: 3px !important;
        background-image: -webkit-radial-gradient(0 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em), -webkit-radial-gradient(100% 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em);
        background-image: radial-gradient(circle at 0 50%, rgba(255, 255, 224, 0) .4em, #f9af00 .5em), radial-gradient(circle at 100% 50%, rgba(255, 255, 224, 0) .4em, #f9af00 .5em);
    }

    .color-danger {
        color: #cc2e1e;
    }

    .color-success {
        color: #00ab04;
    }

    .color-warning {
        color: #e0e000;
    }
</style>

<style scoped>

    .btn-detail-close {
        box-sizing: content-box;
        display: inline-block;
        position: relative;
        padding: 10px 10px 10px 10px;
        color: #684d18;
        font-weight: 700;
        font-size: 14px;
        background-repeat: no-repeat;
        background-image: -webkit-radial-gradient(0 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em), -webkit-radial-gradient(100% 50% circle, rgba(255, 255, 224, 0) .4em, #ffffe0 .5em);
        background-image: radial-gradient(circle at 0 50%, rgba(255, 255, 224, 0) .4em, #d4d4d4 .5em), radial-gradient(circle at 100% 50%, rgba(255, 255, 224, 0) .4em, #d4d4d4 .5em);
        background-position: top left, top right;
        background-color: #fff !important;
        border: none;
        box-shadow: none;
        border-radius: 3px;
    }

    @media (min-width: 992px) {
        .display-desktop {
            display: block;
        }

        .display-mobile {
            display: none;
        }
    }

    @media (max-width: 991px) {
        .display-desktop {
            display: none;
        }

        .display-mobile {
            display: block;
        }
    }

</style>
